import { VFlow } from 'bold-ui'
import { CriteriosVulnerabilidadeFamiliar } from 'graphql/types.generated'

import { CriteriosPontuadosVulnerabilidadeFamiliarTable } from './CriteriosPontuadosVulnerabilidadeFamiliarTable'
import { CriteriosVulnerabilidadeFamiliarList } from './CriteriosVulnerabilidadeFamiliarList'

interface CriteriosVulnerabilidadeFamiliarPanelProps {
  criterios: CriteriosVulnerabilidadeFamiliar
}

export function CriteriosVulnerabilidadeFamiliarPanel(props: Readonly<CriteriosVulnerabilidadeFamiliarPanelProps>) {
  const { criteriosInequivocos, criteriosSugestivos, criteriosPontuados } = props.criterios

  const showCriteriosInequivocos = criteriosInequivocos.length > 0
  const showCriteriosSugestivos = criteriosSugestivos.length > 0
  const showCriteriosPontuados = criteriosPontuados.length > 0

  return (
    <VFlow>
      {showCriteriosInequivocos && (
        <CriteriosVulnerabilidadeFamiliarList titulo='Critérios inequívocos' criterios={criteriosInequivocos} />
      )}
      {showCriteriosSugestivos && (
        <CriteriosVulnerabilidadeFamiliarList titulo='Critérios sugestivos' criterios={criteriosSugestivos} />
      )}
      {showCriteriosPontuados && <CriteriosPontuadosVulnerabilidadeFamiliarTable criterios={criteriosPontuados} />}
    </VFlow>
  )
}
